import React, { FunctionComponent, memo } from "react";

import { ISectionProps, Section } from "@/components/Section";

import { withRouteNavigator } from "./withRouteNavigator";

import "./_route_section.scss";

export interface IClickableSectionProps extends ISectionProps {
  href?: string;
  onClick?: (event: React.MouseEvent<any>) => void;
  target?: string;
}

export const ClickableSection: FunctionComponent<IClickableSectionProps> = memo(props => {
  const baseClass = "route-section";
  const { className, target, ...sectionProps } = props;
  return (
    <a href={props.href} onClick={props.onClick} className={baseClass} target={target}>
      <Section {...sectionProps} className={`${className} ${baseClass}-wrapper`} />
    </a>
  );
});

export const RouteSection = withRouteNavigator<IClickableSectionProps>(ClickableSection);
